<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="19" :offset="1">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                        <el-form-item label="活码名称">
                            <el-input v-model="formInline.subQrName" placeholder="名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="findList">查询</el-button>
                            <el-button type="success" @click="handleAdd">新增</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

            </el-row>
        </div>


        <el-table :data="QrcodeSubList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="subQrName" label="名称"></el-table-column>
            <el-table-column v-if="this.qrType==1" prop="subQrUrl" label="跳转链接"></el-table-column>
            <el-table-column v-if="this.qrType==2" prop="subQrImg" label="微信二维码">
                <template slot-scope="scope">
                    <img :src="scope.row.subQrImg" width="70" height="70"/>
                </template>
            </el-table-column>
            <el-table-column prop="qrSwitchNum" label="切换频率"></el-table-column>
            <el-table-column prop="displayCount" label="累计曝光数"></el-table-column>
            <el-table-column prop="qrScanNum" label="累计长按识别数"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="handleDel(scope.row.id)">删除</el-button>
                    <el-button type="primary" size="mini" @click="handleDownloadExcel(scope.row.id)">统计</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <!-- QRSUB添加编辑 -->
        <el-dialog title="新增/修改" :visible.sync="formVisible" center>
            <el-form :model="formSubQR" label-width="120px">
                <el-form-item label="名称">
                    <el-input v-model="formSubQR.subQrName" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="切换频率">
                    <el-input v-model="formSubQR.qrSwitchNum" placeholder="切换频率"></el-input>
                </el-form-item>
                <el-form-item v-if="this.qrType==1" label="跳转链接">
                    <el-input v-model="formSubQR.subQrUrl" placeholder="跳转链接"></el-input>
                    请以http://或https://开头
                </el-form-item>
<!--                <el-form-item v-if="this.qrType==2" label="微信二维码">-->
<!--                    <el-input v-model="formSubQR.subQrImg" placeholder="微信二维码"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item v-if="this.qrType==2" label="个人微信二维码">
                    <uploadComponents v-model="formSubQR.subQrImg" :urlType="2"></uploadComponents>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveQR()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findQrSubList,addOrEditQrSub,delQrSub,downloadSubQR} from '@/api/api';
    import uploadComponents from '@/components/upload';
    export default {
        data() {
            return {
                qrId : this.$route.query.qrId,
                qrType : this.$route.query.qrType,
                QrcodeSubList: [],
                formVisible : false,
                loading: true,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                    subQrName : ""
                },
                formSubQR:{
                    id : "",
                    qrId : this.qrId,
                    subQrName : "",
                    subQrUrl : "",
                    subQrImg : "",
                    qrSwitchNum : ""
                }
            }
        },
        components:{
            uploadComponents
        },
        //挂载时候执行
        mounted(){
            this.formInline.qrId = this.qrId;
            //初始化首页数据
            this.findList();
        },
        methods: {
            findList(){
                findQrSubList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.QrcodeSubList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleAdd(){
                this.formSubQR.id = "";
                this.formSubQR.qrId = this.qrId;
                this.formSubQR.subQrName = "";
                this.formSubQR.subQrUrl = "";
                this.formSubQR.subQrImg = "";
                this.formSubQR.qrSwitchNum = "";
                this.formVisible = true;
            },
            handleEdit(row){
                this.formSubQR.id = row.id;
                this.formSubQR.qrId = row.qrId;
                this.formSubQR.subQrName = row.subQrName;
                this.formSubQR.subQrUrl = row.subQrUrl;
                this.formSubQR.subQrImg = row.subQrImg;
                this.formSubQR.qrSwitchNum = row.qrSwitchNum;
                this.formVisible = true;
            },
            saveQR(){
                addOrEditQrSub(this.formSubQR).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.formVisible = false;
                        this.findList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleDel(id){
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delQrSub({"qrSubId":id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.formVisible = false;
                            this.findList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            handleDownloadExcel(id){
                window.open(`${downloadSubQR}?qrSubId=` + id)
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>
<style>
    .el-transfer{
        margin-left: 20%;
        height: 600px;
    }
    .el-transfer-panel{
        width:30%;
        height: 600px;
    }
    .el-transfer-panel__list.is-filterable{
        height: 584px;
    }
</style>


// WEBPACK FOOTER //
// src/views/qrcode/subQrcode.vue